import type { ComponentType, SVGProps } from "react";
import { BuildingIcon, FileChartIcon, GraduationIcon, NetworkIcon, SettingsIcon, UsersIcon } from "../Icons";
import { Pricing, money } from "../business-case/calculator";

// Add-on keys come from BusinessCase::Pricing, so an unmapped key falls back rather than crashing.
const ADD_ON_ICONS = {
  programme_design: NetworkIcon,
  mentor_training: GraduationIcon,
  ongoing_management: BuildingIcon,
  outcome_report: FileChartIcon,
  external_mentors: UsersIcon,
};

export const addOnIcon = (key: string) => ADD_ON_ICONS[key as keyof typeof ADD_ON_ICONS] ?? SettingsIcon;

export const WAYS_TO_WORK: {
  key: string;
  icon: ComponentType<SVGProps<SVGSVGElement>>;
  eyebrow: string;
  title: string;
  body: string;
  badge: string | null;
  includes: string[];
}[] = [
  {
    key: "platform",
    icon: SettingsIcon,
    eyebrow: "Platform",
    title: "You run the programme",
    body: "Best for organisations with a defined programme team and internal mentors.",
    badge: null,
    includes: [
      "Participant and cohort management",
      "Matching, scheduling and session tracking",
      "Standard dashboards and support",
    ],
  },
  {
    key: "supported",
    icon: NetworkIcon,
    eyebrow: "Supported programme",
    title: "We help you launch",
    body: "Best when your team wants to retain ownership but needs selected implementation support.",
    badge: "Most flexible",
    includes: [
      "Choose the support you need",
      "Mentor development training",
      "Outcome measurement and reporting",
    ],
  },
  {
    key: "managed",
    icon: UsersIcon,
    eyebrow: "Managed programme",
    title: "We run it with you",
    body: "Best when you need FutureLab to design, coordinate and measure the programme.",
    badge: null,
    includes: [
      "Programme and journey design",
      "Ongoing participant management",
      "Internal or external mentor options",
    ],
  },
];

